import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { EnvironmentConfig } from '../../environments/environmentConfig';
import { AdobeAnalyticsService } from './adobe-analytics.service';
import { UtilService } from 'src/app/service/util.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor(private envConfObj: EnvironmentConfig,
    public router: Router,
    private _activatedRoute: ActivatedRoute,
    private adobeAnalytics: AdobeAnalyticsService,
    private translate: TranslateService, private util: UtilService
  ) { }

  canActivate() {
    window.scrollTo(0, 0);
    window.scroll(0, 0);

    var enableGoogleKey = true;
    var google_api_key = environment.api.googlemapapi;
    if (!document.getElementById("uniqueMapIDD")) {
      if (enableGoogleKey) {
        var script = document.createElement('script');
        if (google_api_key != '') {
          script.id = "uniqueMapIDD"
          script.src = 'https://maps.googleapis.com/maps/api/js?key=' + google_api_key + '&libraries=places&callback=initAutocomplete';
          $("head").append(script.outerHTML);
          sessionStorage.setItem("google", "true");
        } else {
          sessionStorage.setItem("google", "false");
        }
      } else {
        sessionStorage.setItem("google", "false");
      }
    }
    if (String(this.envConfObj.environment.production) === String(true) && !sessionStorage.getItem("pre_qual_data")) {

      this.router.navigate(["../home"], { relativeTo: this._activatedRoute });
      return false;
    }
    if (!sessionStorage.getItem("pre_qual_data")) {

      this.router.navigate(["../home"], { relativeTo: this._activatedRoute });
      return false;
    }

    this.translate.onLangChange.subscribe((e: LangChangeEvent) => {
      let lang = e.lang || "en";
      let curLng = sessionStorage.getItem("currLang");
      let lang_ref = sessionStorage.getItem("lang_ref");
      if (curLng != lang_ref) {

        if (!curLng) {
          window.location.href = environment.api.mortgageHome_en;
        }
        else {
          if (curLng == 'en') {
            window.location.href = environment.api.mortgageHome_en;
          } else {
            window.location.href = environment.api.mortgageHome_fr;
          }

        }

      }
      if (sessionStorage.getItem("currLang") != e.lang) {
        sessionStorage.clear();
        if (sessionStorage.getItem("currLang") != null) {
          window.location.href = "https://www.cibc.com/" + sessionStorage.getItem("currLang") + "/personal-banking/mortgages.html";

        }
        else {
          window.location.href = "https://www.cibc.com/" + e.lang + "/personal-banking/mortgages.html"
        }
      }
    });

    return true;

  }

  getSessionStorage() {
    let sessionData = this.util.getSessionStorage();
    /*let sessionData = sessionStorage.getItem('pre_qual_data');
    if (sessionData && sessionData !== "undefined") {
      return JSON.parse(atob(sessionData));
    }*/
    return sessionData;
  }
}
